export type NonFsdsTheme = 'general' | 'english-academy' | 'programming' | 'math'

const THEME_ALIASES: Record<string, NonFsdsTheme> = {
  general: 'general',
  'english-academy': 'english-academy',
  programming: 'programming',
  math: 'math',
}

/**
 * Normalize theme values from edunode-be catalog / legacy Puck data.
 * Unknown values fall back to general so public pages never crash SSR/CSR.
 */
export function resolveNonFsdsTheme(theme?: string | null): NonFsdsTheme {
  if (theme && theme in THEME_ALIASES) {
    return THEME_ALIASES[theme]
  }
  return 'general'
}
